import englishFlag from 'assets/images/flags/en.svg?url';
import spanishFlag from 'assets/images/flags/es.svg?url';
import swedishFlag from 'assets/images/flags/sv.svg?url';
import finnishFlag from 'assets/images/flags/fi.svg?url';
import norwegianFlag from 'assets/images/flags/no.svg?url';
import danishFlag from 'assets/images/flags/da.svg?url';

import en from './locale_en';
import enCharity from './locale_en-x-charity';
import enInsurance from './locale_en-x-insure';
import es from './locale_es';
import sv from './locale_sv';
import svCharity from './locale_sv-x-charity';
import svInsurance from './locale_sv-x-insure';
import svFinland from './locale_sv-FI';
import svFinlandInsurance from './locale_sv-FI-x-insure';
import svMembership from './locale_sv-x-member';
import fi from './locale_fi';
import fiInsurance from './locale_fi-x-insure';
import da from './locale_da';
import daInsurance from './locale_da-x-insure';
import no from './locale_no';
import noInsurance from './locale_no-x-insure';

const defaultLocale = 'sv';

const locales = {
  en: {
    name: 'English',
    flag: englishFlag,
    translations: en
  },
  'en-x-charity': {
    name: 'English',
    flag: englishFlag,
    translations: enCharity
  },
  'en-x-insure': {
    name: 'English',
    flag: englishFlag,
    translations: enInsurance
  },
  es: {
    name: 'Español',
    flag: spanishFlag,
    translations: es
  },
  sv: {
    name: 'Svenska',
    flag: swedishFlag,
    translations: sv
  },
  'sv-x-charity': {
    name: 'Svenska',
    flag: swedishFlag,
    translations: svCharity
  },
  'sv-x-insure': {
    name: 'Svenska',
    flag: swedishFlag,
    translations: svInsurance
  },
  'sv-x-member': {
    name: 'Svenska',
    flag: swedishFlag,
    translations: svMembership
  },
  'sv-fi': {
    name: 'Svenska',
    flag: finnishFlag,
    translations: svFinland
  },
  'sv-fi-x-insure': {
    name: 'Svenska',
    flag: finnishFlag,
    translations: svFinlandInsurance
  },
  fi: {
    name: 'Suomi',
    flag: finnishFlag,
    translations: fi
  },
  'fi-x-insure': {
    name: 'Suomi',
    flag: finnishFlag,
    translations: fiInsurance
  },
  no: {
    name: 'Norsk',
    flag: norwegianFlag,
    translations: no
  },
  'no-x-insure': {
    name: 'Norsk',
    flag: norwegianFlag,
    translations: noInsurance
  },
  da: {
    name: 'Dansk',
    flag: danishFlag,
    translations: da
  },
  'da-x-insure': {
    name: 'Dansk',
    flag: danishFlag,
    translations: daInsurance
  }
};

const languages = Object.keys(locales);

export {
  defaultLocale,
  locales,
  languages
};
